<script setup lang="ts">
import Button from '../Button.vue';
import Logo from '../Logo.vue';

const props = withDefaults(defineProps<{
	title?: string;
	overline?: string;
	hasClose?: boolean;
}>(), {
	hasClose: true,
});

const emit = defineEmits<{
	(event: 'update:visible', value: boolean): void;
}>();
</script>

<template>
	<div class="dialog-response-header">
		<div class="dialog-response-header__header">
			<Logo />

			<div class="dialog-response-header__close" v-if="props.hasClose">
				<Button
					icon="x"
					severity="dark"
					size="lg"
					aria-label="Close"
					@click="emit('update:visible', false)"
				/>
			</div>
		</div>

		<div class="dialog-response-header__content" v-if="props.overline || props.title">
			<span class="dialog-response-header__overline" v-if="props.overline">{{ props.overline }}</span>
			<h2 class="dialog-response-header__title" v-if="props.title">
				{{ props.title }}
			</h2>
		</div>
	</div>
</template>

<style scoped lang="scss">
@layer hm-components
{
	.dialog-response-header
	{
		@include flex(null, null, var(--spacing-2xl));
		flex-direction:column;

		&__header
		{
			@include flex(between, start);
			padding-block-end:var(--spacing-md);

			&:deep(.logo)
			{
				@include size(197, 54);
			}
		}
		&__close
		{
			flex-shrink:0;
			@include flex;
		}
		&__content
		{
			@include flex(null, null, var(--spacing-sm));
			flex-direction:column;
		}
		&__overline
		{
			color:var(--c-title);
			@include text-overline(sm);
			font-weight:600;
		}
		&__title
		{
			color:var(--c-title);
			@include text-title-entry;
		}
	}
}
</style>
